/**
 * Error Handling Configuration
 * 
 * This configuration file defines global settings for the error handling system.
 * These settings control error display behavior, retry logic, and animation properties.
 */

const errorConfig = {
  /**
   * Auto-hide delay for non-critical errors (in milliseconds)
   * Non-critical errors (client errors) will automatically dismiss after this duration
   * Set to 0 to disable auto-hide
   */
  autoHideDelay: 10000,

  /**
   * Maximum number of retry attempts for retryable errors
   * After reaching this limit, the retry button will be disabled
   */
  maxRetryAttempts: 3,

  /**
   * Array of API endpoint patterns to exclude from global error handling
   * Errors from these endpoints will not trigger the global error display
   * Supports string patterns (partial match) or RegExp patterns
   * Example: ['/api/auth/login', '/VarunathApi', 'health']
   */
  excludedEndpoints: [
    // Add your Varunath data loading endpoint here
    // Example: '/VarunathApi', 'varunath', or any pattern that matches your endpoint
  ],

  /**
   * Enable error history tracking
   * When enabled, maintains a history of the last 10 errors for debugging
   */
  enableErrorHistory: true,

  /**
   * Enable console logging of errors
   * When enabled, logs detailed error information to the browser console
   */
  enableConsoleLogging: true,

  /**
   * Animation duration for error display (in milliseconds)
   * Controls the speed of entry and exit animations
   */
  animationDuration: 400,

  /**
   * Animation easing function
   * CSS cubic-bezier values for smooth animations
   */
  animationEasing: 'cubic-bezier(0.4, 0, 0.2, 1)',

  /**
   * Backdrop opacity for error overlay
   * Value between 0 (transparent) and 1 (opaque)
   */
  backdropOpacity: 0.5,

  /**
   * Icon animation settings for different error types
   */
  iconAnimations: {
    network: {
      type: 'pulse',
      duration: 1500,
      iterations: 'infinite'
    },
    server: {
      type: 'shake',
      duration: 500,
      iterations: 'infinite'
    },
    client: {
      type: 'bounce',
      duration: 1000,
      iterations: 'infinite'
    },
    auth: {
      type: 'pulse',
      duration: 1500,
      iterations: 'infinite'
    }
  }
};

export default errorConfig;
